import { z } from "zod";
import { adminAuditFieldsSchema } from "./IAdminAudit";


export const KURTAXE_CATEGORIES = [
    { value: '', label: 'Steuerfrei / keine Kurtaxe' },
    { value: 'EW', label: 'Erwachsene (18+)' },
    { value: 'AGE_7_17', label: '7-17 Jahre' },
    { value: 'AGE_0_6', label: '0-6 Jahre' },
] as const;

export const reservationPriceSchema = adminAuditFieldsSchema.extend({
    id: z.number().default(-1),
    name: z.string().default(''),
    price: z.coerce.number().default(0),
    kurtaxe_category: z.enum(['', 'EW', 'AGE_7_17', 'AGE_0_6']).default(''),
});

export type IReservationPrice = z.infer<typeof reservationPriceSchema>;

export const kurtaxeRateSchema = z.object({
    category: z.enum(['EW', 'AGE_7_17', 'AGE_0_6']),
    category_display: z.string().optional(),
    rate: z.coerce.number().default(0),
    updated_at: z.string().nullable().optional(),
});

export type IKurtaxeRate = z.infer<typeof kurtaxeRateSchema>;
